import * as React from 'react';
import styles from './index.less';
import { Affix, Checkbox, Modal, Space } from 'antd';
import FTable from '@/components/FTable';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, StorageHomePageModelState } from '@/models/connect';
import {
  DeleteObjectAction,
  FetchObjectsAction,
  FetchSpaceStatisticAction,
  FetchBucketsAction,
  ChangeAction,
  OnBatchDeleteObjectsAction,
  OnBatchUpdateObjectsAction,
} from '@/models/storageHomePage';
import FNoDataTip from '@/components/FNoDataTip';
import FLoadingTip from '@/components/FLoadingTip';
import type { ColumnsType } from 'antd/es/table';
import FTooltip from '@/components/FTooltip';
import FLink from '@/components/FLink';
import { FUtil, FServiceAPI, FI18n } from '@freelog/tools-lib';
import NoBucket from '@/pages/storage/NoBucket';
import FListFooter from '@/components/FListFooter';
import FComponentsLib from '@freelog/components-lib';
import fReadLocalFiles from '@/components/fReadLocalFiles';
import FStorageUploadTasksPanel2, {
  getStorageUploadTasksPanel2,
} from '@/components/FStorageUploadTasksPanel2';
import * as AHooks from 'ahooks';
import Details from './Details';
import fCenterMessage from '@/components/fCenterMessage';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FPrompt2 from '@/components/FPrompt2';
import FFileTypeIcon from '@/components/FFileTypeIcon';

interface ContentProps {
  dispatch: Dispatch;
  storageHomePage: StorageHomePageModelState;
}

function Content({ storageHomePage, dispatch }: ContentProps) {
  const [$affixed, set$affixed, get$affixed] = FUtil.Hook.useGetState<boolean>(false);
  const scroll = AHooks.useScroll(self.document.getElementById('rightContent'));
  const [$incompleteTask, set$IncompleteTask, get$IncompleteTask] =
    AHooks.useGetState<boolean>(false);

  AHooks.useDebounceEffect(
    () => {
      const allIDs: string[] = storageHomePage.object_List.map((ol) => {
        return ol.id;
      });

      dispatch<ChangeAction>({
        type: 'storageHomePage/change',
        payload: {
          checkedObjectIDs: storageHomePage.checkedObjectIDs.filter((id) => {
            return allIDs.includes(id);
          }),
        },
      });
    },
    [storageHomePage.object_List],
    {
      wait: 30,
    },
  );

  const isUserDataBucket = storageHomePage.activatedBucket === '.UserNodeData';

  const columns: ColumnsType<NonNullable<StorageHomePageModelState['object_List']>[number]> = [
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
          }}
        >
          <Checkbox
            checked={storageHomePage.checkedObjectIDs.length === storageHomePage.object_List.length}
            indeterminate={
              storageHomePage.checkedObjectIDs.length !== 0 &&
              storageHomePage.checkedObjectIDs.length !== storageHomePage.object_List.length
            }
            onChange={(e) => {
              if (e.target.checked) {
                dispatch<ChangeAction>({
                  type: 'storageHomePage/change',
                  payload: {
                    checkedObjectIDs: storageHomePage.object_List.map((o) => {
                      return o.id;
                    }),
                  },
                });
              } else {
                dispatch<ChangeAction>({
                  type: 'storageHomePage/change',
                  payload: {
                    checkedObjectIDs: [],
                  },
                });
              }
            }}
          />
          <FComponentsLib.FTitleText
            style={{ display: 'inline-block' }}
            type='table'
            text={'全选'}
          />
        </div>
      ),
      dataIndex: 'checked',
      key: 'checked',
      render(text, record) {
        return (
          <Checkbox
            checked={storageHomePage.checkedObjectIDs.includes(record.id)}
            onChange={(e) => {
              if (e.target.checked) {
                dispatch<ChangeAction>({
                  type: 'storageHomePage/change',
                  payload: {
                    checkedObjectIDs: [...storageHomePage.checkedObjectIDs, record.id],
                  },
                });
              } else {
                dispatch<ChangeAction>({
                  type: 'storageHomePage/change',
                  payload: {
                    checkedObjectIDs: storageHomePage.checkedObjectIDs.filter((id) => {
                      return id !== record.id;
                    }),
                  },
                });
              }
            }}
          />
        );
      },
      width: 100,
    },
    {
      title: '',
      dataIndex: 'icon',
      width: 50,
      key: 'icon',
      render(_, record) {
        // if (record.mime?.startsWith('text/')) {
        //   return <img src={img_txt} alt={''} style={{ width: 36 }} />;
        // }

        // if (record.mime?.startsWith('audio/')) {
        //   return <img src={img_audio} alt={''} style={{ width: 36 }} />;
        // }

        // if (record.mime?.startsWith('video/')) {
        //   return <img src={img_video} alt={''} style={{ width: 36 }} />;
        // }

        // if (record.mime?.startsWith('image/')) {
        //   return <img src={img_image} alt={''} style={{ width: 36 }} />;
        // }

        // if (
        //   [
        //     'application/gzip',
        //     'application/x-gzip',
        //     'application/zip',
        //     'application/rar',
        //     'application/vnd.rar',
        //     'application/tar',
        //     'application/x-tar',
        //   ].includes(record.mime)
        // ) {
        //   return <img src={img_zip} alt={''} style={{ width: 36 }} />;
        // }

        // if (record.mime?.startsWith('application/pdf')) {
        //   return <img src={img_pdf} alt={''} style={{ width: 36 }} />;
        // }

        // if (record.mime === 'application/vnd.freelog.comic') {
        //   return <img src={img_cartoon} alt={''} style={{ width: 50 }} />;
        // }

        // return <img src={img_general} alt={''} style={{ width: 36 }} />;
        return <FFileTypeIcon mime={record.mime} style={{ width: 36 }} />;
      },
    },
    {
      title: <FComponentsLib.FTitleText type='table' text={FI18n.i18nNext.t('object_name')} />,
      dataIndex: 'name',
      key: 'name',
      render(text, record) {
        return (
          <Space size={10}>
            <FComponentsLib.FContentText
              type='normal'
              text={text}
              singleRow
              style={{ maxWidth: 700 }}
            />
            <div className={styles.hoverVisible}>
              <FCopyToClipboard
                text={`${storageHomePage.activatedBucket}/${text}`}
                title={FI18n.i18nNext.t('copy_object_name')}
              />
            </div>
          </Space>
        );
      },
    },
    {
      title: '',
      dataIndex: 'tool',
      key: 'tool',
      width: 150,
      render(text, record) {
        return (
          <div className={styles.hoverVisible}>
            <ToolsBar
              bucketName={record.bucketName}
              objectID={record.id}
              showDelete={!isUserDataBucket}
              showEdit={!isUserDataBucket}
              onClickDownload={() =>
                FServiceAPI.Storage.downloadObject({
                  objectIdOrName: record.id,
                })
              }
              onClickDelete={async () => {
                const bool: boolean = await fPromiseModalConfirm({
                  title: '提示',
                  description: FI18n.i18nNext.t('msg_delete_object_confirm'),
                  cancelText: FI18n.i18nNext.t('btn_cancel'),
                  okText: FI18n.i18nNext.t('btn_delete_object'),
                });

                if (bool) {
                  onClickDelete(record);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: <FComponentsLib.FTitleText type='table' text={FI18n.i18nNext.t('resource_type')} />,
      dataIndex: 'type',
      key: 'type',
      width: 140,
      render(text, record) {
        if (record.type.length === 0) {
          return <FComponentsLib.FContentText type='negative' text={'未设置类型'} />;
        }
        return (
          <FComponentsLib.FContentText
            text={FUtil.Format.resourceTypeKeyArrToResourceType(record.type)}
          />
        );
      },
    },
    {
      title: <FComponentsLib.FTitleText type='table' text={FI18n.i18nNext.t('size')} />,
      dataIndex: 'size',
      key: 'size',
      width: 120,
      render(text: any, record: any): any {
        return <FComponentsLib.FContentText type='normal' text={text} />;
      },
    },
    {
      title: (
        <FComponentsLib.FTitleText type='table' text={FI18n.i18nNext.t('last_updated_time')} />
      ),
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 150,
      render(text: any, record: any): any {
        return <FComponentsLib.FContentText type='normal' text={text} />;
      },
    },
  ];

  function onClickDelete(record: any) {
    dispatch<DeleteObjectAction>({
      type: 'storageHomePage/deleteObject',
      payload: record.id,
    });
  }

  if (storageHomePage.bucketList?.length === 0) {
    return <NoBucket />;
  }

  return (
    <div>
      <FPrompt2
        watch={$incompleteTask}
        reconfirm={(location) => {
          // console.log('location', location);
          return !location.pathname.startsWith('/storage');
        }}
        messageText={'有未完成的上传任务，确认离开？'}
        // onOk={() => {
        //   set$IncompleteTask(false);
        // }}
        okText={'离开'}
        cancelText={'取消'}
      />

      {storageHomePage.object_ListState === 'loading' && (
        <FLoadingTip height={'calc(100vh - 170px)'} />
      )}

      {storageHomePage.object_ListState === 'noData' && storageHomePage.filterInput === '' && (
        <>
          <FNoDataTip
            height={'calc(100vh - 170px)'}
            tipText={FI18n.i18nNext.tAuto('objects_list_empty')}
            btn={
              <FComponentsLib.FRectBtn
                onClick={async () => {
                  const files = await fReadLocalFiles({
                    multiple: true,
                  });
                  if (!files) {
                    return;
                  }
                  // (await getStorageUploadTasksPanel()).addTask(files);
                  (await getStorageUploadTasksPanel2()).addTask(files);
                }}
                size='large'
                type='primary'
                style={{ paddingLeft: 50, paddingRight: 50 }}
              >
                {FI18n.i18nNext.tAuto('upload_object')}
              </FComponentsLib.FRectBtn>
            }
          />
        </>
      )}

      {storageHomePage.object_ListState === 'noSearchResult' &&
        storageHomePage.filterInput !== '' && (
          <>
            <FNoDataTip height={'calc(100vh - 170px)'} tipText={'无搜索结果'} />
          </>
        )}

      {storageHomePage.object_ListState === 'loaded' && (
        <>
          {storageHomePage.checkedObjectIDs.length > 0 && (
            <>
              <div style={{ height: 30 }} />
              <Affix
                offsetTop={0}
                // target={() => self.document.getElementById('rightContent')}
                target={() => {
                  return self.document.querySelector(
                    '#rightContent .simplebar-content-wrapper',
                  ) as HTMLElement;
                }}
                onChange={(affixed) => {
                  set$affixed(affixed ?? false);
                }}
              >
                <div
                  className={styles.handled}
                  style={
                    $affixed
                      ? {
                          backgroundColor: 'white',
                          marginLeft: -20,
                          marginRight: -20,
                          paddingLeft: 40,
                          paddingRight: 40,
                          justifyContent: 'space-between',
                          height: 70,
                        }
                      : {}
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 30,
                    }}
                  >
                    {(scroll?.top || 0) > 170 && (
                      <Space size={5}>
                        <Checkbox
                          checked={
                            storageHomePage.checkedObjectIDs.length ===
                            storageHomePage.object_List.length
                          }
                          indeterminate={
                            storageHomePage.checkedObjectIDs.length !== 0 &&
                            storageHomePage.checkedObjectIDs.length !==
                              storageHomePage.object_List.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              dispatch<ChangeAction>({
                                type: 'storageHomePage/change',
                                payload: {
                                  checkedObjectIDs: storageHomePage.object_List.map((o) => {
                                    return o.id;
                                  }),
                                },
                              });
                            } else {
                              dispatch<ChangeAction>({
                                type: 'storageHomePage/change',
                                payload: {
                                  checkedObjectIDs: [],
                                },
                              });
                            }
                          }}
                        />
                        <FComponentsLib.FTitleText
                          style={{ display: 'inline-block' }}
                          type='table'
                          text={'全选'}
                        />
                      </Space>
                    )}

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      style={{ fontSize: 14 }}
                      // text={'已选择2个对象，可进行操作:'}
                      text={FI18n.i18nNext.tAuto('storage_bulkaction_label_selectedqty', {
                        ObjectQty: storageHomePage.checkedObjectIDs.length,
                      })}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 30,
                    }}
                  >
                    <FComponentsLib.FTextBtn
                      // disabled={storageHomePage.checkedObjectIDs.length === 0}
                      type={'primary'}
                      onClick={() => {
                        if (storageHomePage.checkedObjectIDs.length === 0) {
                          return fCenterMessage({
                            message: '请选择要执行操作的对象',
                          });
                        }
                        dispatch<OnBatchUpdateObjectsAction>({
                          type: 'storageHomePage/onBatchUpdateObjects',
                        });
                      }}
                    >
                      <FIcons.FConfiguration style={{ fontSize: 14 }} />
                      &nbsp;{FI18n.i18nNext.tAuto('storage_bulkaction_btn_settype')}
                    </FComponentsLib.FTextBtn>

                    <FComponentsLib.FTextBtn
                      type={'danger'}
                      // disabled={storageHomePage.checkedObjectIDs.length === 0}
                      onClick={async () => {
                        // console.log('(*YOIOIUY*(OUOIJLKJLkj');
                        if (storageHomePage.checkedObjectIDs.length === 0) {
                          return fCenterMessage({
                            message: '请选择要执行操作的对象',
                          });
                        }

                        const bool: boolean = await fPromiseModalConfirm({
                          title: '提示',
                          description: FI18n.i18nNext.t('msg_delete_object_confirm'),
                          cancelText: FI18n.i18nNext.t('btn_cancel'),
                          okText: FI18n.i18nNext.t('btn_delete_object'),
                        });

                        if (bool) {
                          dispatch<OnBatchDeleteObjectsAction>({
                            type: 'storageHomePage/onBatchDeleteObjects',
                          });
                        }
                      }}
                    >
                      <FIcons.FDelete style={{ fontSize: 14 }} />
                      &nbsp;
                      {FI18n.i18nNext.tAuto('storage_bulkaction_btn_deleteobject')}
                    </FComponentsLib.FTextBtn>
                  </div>
                </div>
              </Affix>
            </>
          )}

          <div style={{ height: 30 }} />
          <div className={styles.body}>
            <FTable
              rowClassName={styles.rowClassName}
              columns={columns}
              dataSource={storageHomePage.object_List.map((i) => {
                return {
                  ...i,
                };
              })}
              pagination={false}
            />
            <FListFooter
              state={storageHomePage.object_ListMore}
              onClickLoadMore={() => {
                dispatch<FetchObjectsAction>({
                  type: 'storageHomePage/fetchObjects',
                  payload: 'append',
                });
              }}
            />
          </div>
        </>
      )}

      <FStorageUploadTasksPanel2
        bucketName={storageHomePage.activatedBucket}
        availableStorageSize={storageHomePage.totalStorage - storageHomePage.usedStorage}
        onSuccess={() => {
          dispatch<FetchObjectsAction>({
            type: 'storageHomePage/fetchObjects',
            payload: 'insert',
          });
          dispatch<FetchSpaceStatisticAction>({
            type: 'storageHomePage/fetchSpaceStatistic',
          });
          dispatch<FetchBucketsAction>({
            type: 'storageHomePage/fetchBuckets',
          });
        }}
        onChange_incompleteTask={(bool) => {
          set$IncompleteTask(bool);
        }}
      />

      {/* <FStorageUploadTasksPanel2
        bucketName={storageHomePage.activatedBucket}
        availableStorageSize={
          storageHomePage.totalStorage - storageHomePage.usedStorage
        }
        onSuccess={() => {
          dispatch<FetchObjectsAction>({
            type: 'storageHomePage/fetchObjects',
            payload: 'insert',
          });
        }}
      /> */}

      <Details />
    </div>
  );
}

export default connect(({ storageHomePage }: ConnectState) => ({
  storageHomePage: storageHomePage,
}))(Content);

interface ToolsBarProps {
  bucketName: string;
  objectID: string;
  showEdit?: boolean;
  showDownload?: boolean;
  showDelete?: boolean;

  onClickDownload?(): void;

  onClickDelete?(): void;
}

function ToolsBar({
  bucketName,
  objectID,
  showEdit = true,
  showDownload = true,
  showDelete = true,
  onClickDownload,
  onClickDelete,
}: ToolsBarProps) {
  return (
    <Space className={styles.toolBar} size={25}>
      {showEdit && (
        <FTooltip title={FI18n.i18nNext.tAuto('tip_edit_object')}>
          <FLink
            to={FUtil.LinkTo.objectDetails({
              bucketName,
              objectID: objectID,
            })}
          >
            <FIcons.FEdit />
          </FLink>
        </FTooltip>
      )}
      {showDownload && (
        <FTooltip title={FI18n.i18nNext.tAuto('tip_download_object')}>
          <span>
            <FComponentsLib.FTextBtn
              onClick={() => onClickDownload && onClickDownload()}
              type='primary'
            >
              <FIcons.FDownload />
            </FComponentsLib.FTextBtn>
          </span>
        </FTooltip>
      )}
      {showDelete && (
        <FTooltip title={FI18n.i18nNext.tAuto('tip_delete')}>
          <span>
            <FComponentsLib.FTextBtn
              type={'danger'}
              onClick={() => onClickDelete && onClickDelete()}
              className={styles.Delete}
            >
              <FIcons.FDelete />
            </FComponentsLib.FTextBtn>
          </span>
        </FTooltip>
      )}
    </Space>
  );
}
